// extracted by mini-css-extract-plugin
export default {"blurb":"FeatureArt_blurb__63nTl","colsWrapper":"FeatureArt_colsWrapper__EzvO0"};